const calculateClosestEdge = (
    event: DragEvent,
    dir = 'ltr',
    iframWidth: number,
    axis?: 'x' | 'y',
) => {
    const rtl = dir === 'rtl';

    const rect = event.target.getBoundingClientRect();

    const x = rtl ? rect.right - event.clientX : event.clientX - rect.left;
    const y = event.clientY - rect.top;

    const leftDist = rtl ? rect.width - x : x;
    const rightDist = rtl ? x : rect.width - x;
    const topDist = y;
    const bottomDist = rect.height - y;

    const left = rtl ? 'right' : 'left';
    const right = rtl ? 'left' : 'right';

    if (axis === 'y') {
        const minY = Math.min(topDist, bottomDist);
        if (minY === topDist) return ['top', minY];
        if (minY === bottomDist) return ['bottom', minY];
    }

    if (axis === 'x') {
        const minX = Math.min(leftDist, rightDist);
        if (minX === leftDist) return [left, minX];
        if (minX === rightDist) return [right, minX];
    }

    const minDist = Math.min(leftDist, rightDist, topDist, bottomDist);

    if (minDist === leftDist) return [left, minDist];
    if (minDist === rightDist) return [right, minDist];
    if (minDist === topDist) return ['top', minDist];
    if (minDist === bottomDist) return ['bottom', minDist];
};

export { calculateClosestEdge };
